import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import api, { formatApiErrorDetail } from "./api";
import { AuthShell } from "./Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(data.message);
      navigate("/portal/login", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Reset Password" subtitle="Invalid reset link.">
        <p className="text-sm" style={{ color: "#94A3B8" }}>
          This reset link is missing or invalid. Please request a new one.
        </p>
        <div className="mt-6">
          <Link to="/portal/forgot-password" className="mono-label hover:text-cyan" style={{ color: "#00F0FF" }}>Request new link →</Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Reset Password" subtitle="Choose a new password for your account.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div>
          <label className="mono-label block mb-2" style={{ color: "#94A3B8" }}>New Password</label>
          <input type="password" required minLength={6} className="field" placeholder="At least 6 characters"
            value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" />
        </div>
        <div>
          <label className="mono-label block mb-2" style={{ color: "#94A3B8" }}>Confirm Password</label>
          <input type="password" required minLength={6} className="field" placeholder="Re-enter password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
        </div>
        <button type="submit" disabled={loading} data-testid="reset-submit"
          className="group w-full flex items-center justify-center gap-2 bg-[#0066FF] hover:bg-[#00F0FF] text-white hover:text-[#060A14] px-6 py-3.5 mono-label transition-colors duration-300 disabled:opacity-60">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <>Update Password <ArrowRight size={16} className="cta-arrow" /></>}
        </button>
      </form>
    </AuthShell>
  );
}
